import React, { FC } from 'react';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import { Box, Divider, Typography, useTheme } from '@mui/material';
import { Person, SentimentVeryDissatisfied, SentimentVerySatisfied } from '@mui/icons-material';
import ReviewFooter from '../ReviewFooter';
import ReviewWrapper from '../ReviewWrapper';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';
import ReviewText from '../ReviewText';

interface Props extends IReviewNewProps {}

const ExpediaReview: FC<Props> = ({
  commentingModule,
  communityManagement,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();

  const {
    username,
    header,
    text,
    travelDuration,
    positiveFeedback,
    negativeFeedback,
    stayDate,
    traveledAs,
    rating,
    companyComment,
  } = reviewEntry.review;

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {username && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Person fontSize="small" />
          <Typography
            variant="body1"
            sx={{ ml: theme.spacing(1) }}
          >
            {username}
          </Typography>
        </Box>
      )}
      {traveledAs && traveledAs.length !== 0 && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            color: theme.palette.text.secondary,
          }}
        >
          {traveledAs.map((description) => (
            <Typography
              variant="caption"
              sx={{ color: theme.palette.text.secondary }}
            >
              {description}
            </Typography>
          ))}
        </Box>
      )}
      {stayDate && travelDuration && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Typography variant="caption">{`${stayDate} - ${travelDuration}`}</Typography>
        </Box>
      )}
      {header && (
        <Typography
          variant="h6"
          sx={{
            mt: theme.spacing(2),
          }}
        >
          {header}
        </Typography>
      )}
      <ReviewText text={text} />
      {(positiveFeedback || negativeFeedback) && (
        <Divider
          orientation="horizontal"
          sx={{ mt: theme.spacing(2) }}
        />
      )}
      {positiveFeedback && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: theme.spacing(2),
          }}
        >
          <SentimentVerySatisfied sx={{ color: theme.palette.success.dark }} />
          <Typography
            variant="body2"
            sx={{ ml: theme.spacing(1) }}
          >
            {positiveFeedback}
          </Typography>
        </Box>
      )}
      {negativeFeedback && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: theme.spacing(2),
          }}
        >
          <SentimentVeryDissatisfied sx={{ color: theme.palette.error.dark }} />
          <Typography
            variant="body2"
            sx={{ ml: theme.spacing(1) }}
          >
            {negativeFeedback}
          </Typography>
        </Box>
      )}
    </ReviewWrapper>
  );
};

export default ExpediaReview;
